// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Grid, Segment, Loader, Transition } from 'semantic-ui-react'
import bgimg from '../assets/citybg.png'
import Img from 'react-image'
import ProductHunt from '../components/ProductHunt'
import hero from '../assets/hero.png'
const ImgLoader = <Loader inline='centered' active />

export default class HeroBlock extends Component {
  constructor (props) {
    super(props)
    this.state = {
      show: false
    }
  }
  componentDidMount () {
    setTimeout(
      function () {
        this.setState({
          show: true
        })
      }.bind(this),
      250
    )
  }
  render () {
    return (
      <div
        className='centerX'
        style={{
          backgroundSize: 'cover',
          backgroundPosition: 'bottom',
          backgroundRepeat: 'repeat',
          backgroundImage: 'url(' + bgimg + ')',
          minHeight: '100vh'
        }}>
        <Grid
          reversed='mobile'
          stackable
          verticalAlign='middle'
          style={{ paddingTop: '5vh', paddingBottom: '5vh' }}>
          <Grid.Column width='1' />
          <Grid.Column width='7'>
            <Segment style={{ borderRadius: '7px', padding: '5vh' }}>
              <div className='mb'>
                <h1 style={{fontSize:'3em'}}>The power of no-code mobile app builders. Taken further.</h1>
                <h4>
                  In a fraction of time and cost Murkstom lets you build and deploy 100% native mobile
                  apps for iOS & Android. No drag-n-drop or confusing interfaces, simply use our
                  pre-builts components. Preview your app in real time for free.
                </h4>
              </div>
              <Button color='black' href='/signup' fluid>
                Get started today
              </Button>
              <ProductHunt />
            </Segment>
          </Grid.Column>
          <Grid.Column width='7' className='center'>
            <Img loader={ImgLoader} src={hero} style={{ width: '100%', alignSelf: 'center' }} />
          </Grid.Column>
          <Grid.Column width='1' />

        </Grid>
      </div>
    )
  }
}
